module.exports = __webpack_public_path__ + "img/clouds_5.77fd2da0.png";